import { jsx as _jsx } from "react/jsx-runtime";
import { ICONS } from '../../../icons/index.js';
export const QuaiManager_DropDownCaret = {
    open: _jsx(ICONS.advisorArrowDown.component, {}), close: _jsx(ICONS.advisorArrowDown.component, { className: 'flip' })
};
//# sourceMappingURL=consts.js.map